/**
 * Owner: Masa Bayu
 * File: native-line-metrics.ts
 * Date:Time: 2026-10-05 12:55
 * Description: Native SPSU plate metrics · line-height + first-line indent.
 */

type PlateBox = {
  readonly bbox: { readonly x: number; readonly y: number; readonly width: number; readonly height: number };
  readonly style: { readonly fontSize: number };
};

/** Purata Δy plat berturut · elak lineHeight 1.35 memendekkan perenggan (gap palsu). */
export function nativeLineHeightPt(plates: readonly PlateBox[]): number {
  if (plates.length === 0) return 14;
  const fontSize = plates[0]!.style.fontSize > 0 ? plates[0]!.style.fontSize : plates[0]!.bbox.height;
  if (plates.length < 2) return fontSize * 1.55;
  let sum = 0;
  let count = 0;
  for (let i = 1; i < plates.length; i += 1) {
    const dy = plates[i]!.bbox.y - plates[i - 1]!.bbox.y;
    if (dy > fontSize * 0.8 && dy < fontSize * 2.4) {
      sum += dy;
      count += 1;
    }
  }
  if (count === 0) return fontSize * 1.55;
  return sum / count;
}

export function columnMetrics(plates: readonly PlateBox[]): {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly firstIndent: number;
} {
  const left = Math.min(...plates.map((p) => p.bbox.x));
  const top = Math.min(...plates.map((p) => p.bbox.y));
  const right = Math.max(...plates.map((p) => p.bbox.x + p.bbox.width));
  const firstIndent = Math.max(0, plates[0]!.bbox.x - left);
  return { left, top, width: Math.max(1, right - left), firstIndent };
}
